import React from "react";
import "./GalleryGrid.css";

// Import all 16 images
import img1 from "../assets/images/imgs (1).png";
import img2 from "../assets/images/imgs (2).png";
import img3 from "../assets/images/imgs (3).png";
import img4 from "../assets/images/imgs (4).png";
import img5 from "../assets/images/imgs (5).png";
import img6 from "../assets/images/imgs (6).png";
import img7 from "../assets/images/imgs (7).png";
import img8 from "../assets/images/imgs (8).png";
import img9 from "../assets/images/imgs (9).png";
import img10 from "../assets/images/imgs (10).png";
import img11 from "../assets/images/imgs (11).png";
import img12 from "../assets/images/imgs (12).png";
import img13 from "../assets/images/imgs (13).png";
import img14 from "../assets/images/imgs (14).png";
import img15 from "../assets/images/imgs (15).png";
import img16 from "../assets/images/imgs (16).png";

// Define gallery items
const galleryItems = [
  { id: 1, category: "Education", src: img1, alt: "Education Program 1" },
  { id: 2, category: "Education", src: img2, alt: "Education Program 2" },
  { id: 3, category: "Health Camps", src: img3, alt: "Health Camp 1" },
  { id: 4, category: "Women Empowerment", src: img4, alt: "Women Empowerment 1" },
  { id: 5, category: "Women Empowerment", src: img5, alt: "Women Empowerment 2" },
  { id: 6, category: "Disaster Relief", src: img6, alt: "Disaster Relief Work 1" },
  { id: 7, category: "Disaster Relief", src: img7, alt: "Disaster Relief Work 2" },
  { id: 8, category: "Community Programs", src: img8, alt: "Community Program 1" },
  { id: 9, category: "Community Programs", src: img9, alt: "Community Program 2" },
  { id: 10, category: "Special Events", src: img10, alt: "Special Event 1" },
  { id: 11, category: "Special Events", src: img11, alt: "Special Event 2" },
  { id: 12, category: "Education", src: img12, alt: "Education Program 3" },
  { id: 13, category: "Health Camps", src: img13, alt: "Health Camp 2" },
  { id: 14, category: "Community Programs", src: img14, alt: "Community Program 3" },
  { id: 15, category: "Special Events", src: img15, alt: "Special Event 3" },
  { id: 16, category: "Disaster Relief", src: img16, alt: "Disaster Relief Work 3" },
];

const GalleryGrid = ({ category }) => {
  const filteredItems =
    category === "All"
      ? galleryItems
      : galleryItems.filter((item) => item.category === category);

  // Assign bento classes dynamically for variation
  const getBentoClass = (id) => {
    if (id % 7 === 0) return "wide";
    if (id % 5 === 0) return "tall";
    return "";
  };

  return (
    <section className="gallery-grid">
      {filteredItems.length > 0 ? (
        filteredItems.map((item) => (
          <div key={item.id} className={`gallery-item ${getBentoClass(item.id)}`}>
            <img src={item.src} alt={item.alt} />
            <div className="gallery-overlay">
              <p>{item.alt}</p>
            </div>
          </div>
        ))
      ) : (
        <p className="no-results">No images found for {category}.</p>
      )}
    </section>
  );
};

export default GalleryGrid;
